import { Component, effect, HostBinding, input, OnChanges } from '@angular/core';

import { R1BrandingConstants } from '@r1-compass-library/constants';
import { SingleField } from '../single-field.model';

/**
 * @description Note - styling of the fields projected into this component is defined in `styles.scss` of the app
 *              <ng-content> styling required heavy handed DOM stuff, either directives or global style sheet.
 *              Link to why and how in that file. If you need to target more than `mat-form-field`, add it there too.
 *              And for non `mat-form-field`, for example a checkbox, see properties to offset assumptions, such as margin.
 */
@Component({
    selector: 'r1-compass-lib-field-field',
    imports: [],
    template: ` <ng-content /> `,
    // See @HostBinding and project's root 'styles.scss', since styling projected stuff is is tricky
    styles: ``,
})
export class FieldFieldComponent implements OnChanges, SingleField {
    fieldWidth = input.required<number>();
    justifyContent = input<'center' | 'flex-start'>('center');
    styleVisibility = input<string>();

    /**
     * @description `mat-form-field` need 21.5px for their error messages as of ng17.2.
     *              Most of these projected fields are `mat-form-field`, but set this to `false`
     *              for other things, such as checkboxes for example, so they are set in the middle.
     */
    offsetTop = input<boolean>(true);

    /*** Set in @see {@link FieldRowComponent} */
    @HostBinding('style.width') widthPer!: string;
    @HostBinding('style.justify-content') contentJustify: string | undefined;

    // Preset ones
    @HostBinding('style.padding') padding = '4px';
    @HostBinding('style.background-color') backgroundColor = R1BrandingConstants.lightGray;
    @HostBinding('style.display') display = 'flex';
    @HostBinding('style.margin-top') marginTop = '21.5px';

    ngOnChanges() {
        this.fieldWidth() ?? console.error('Field `fieldWidth` required in `<r1-field-field>`');
    }

    // TODO - rename this to encompass setting stuff in general, since this is more than width now
    public setWidthPer(width: string) {
        this.widthPer = width;
        this.contentJustify = this.justifyContent();
    }

    public setVisibility(visibility: string) {}

    constructor() {
        // This is a decent use of signal effects to be worth exception
        effect(
            () => {
                if (!this.offsetTop()) {
                    this.marginTop = '0px';
                } else {
                    this.marginTop = '21.5px';
                }
            },
            { debugName: 'margin top setting' }
        );
    }
}
